var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import { PrivateContext } from './IdentityProvider';
import { LoggedOut } from './';
function LoginStatus({ authenticated = false, refreshing = false }) {
    return (React.createElement("div", null,
        "You are ",
        authenticated || 'not',
        " logged in",
        refreshing && ' and your token is being automatically refreshed',
        "."));
}
function silentLogin({ dispatch, userManager, setRunning }) {
    return __awaiter(this, void 0, void 0, function* () {
        yield userManager.removeUser();
        try {
            yield userManager.signinSilent();
            const user = yield userManager.getUser();
            dispatch({ type: 'AUTHENTICATED', user });
        }
        catch (error) {
            if (error.error === 'login_required') {
                console.warn('Silent login failed because user is not logged into IdP.  Redirecting to login');
                window.localStorage.setItem('isLoggedIn', 'false');
                yield userManager.removeUser();
                yield userManager.signinRedirect();
            }
            else {
                dispatch({ type: 'FATAL_ERROR', error, reason: 'Cannot perform silent signin' });
            }
        }
    });
}
function resumeLogin({ dispatch, userManager, setRunning }) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield userManager.getUser();
        if (user) {
            if (!user.expired) {
                console.log('Valid user found in UserManager, marking as authenticated');
                dispatch({ type: 'AUTHENTICATED', user });
            }
            else {
                console.log('Expired user found in UserManager, redirecting to signin');
                yield userManager.removeUser();
                yield userManager.signinRedirect();
            }
        }
        else {
            try {
                yield silentLogin({ userManager, dispatch, setRunning });
            }
            catch (error) {
                dispatch({ type: 'FATAL_ERROR', error, reason: 'Cannot perform silent signin from resumeLogin' });
            }
        }
    });
}
function silentRefresh({ dispatch, userManager, setRunning }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield userManager.signinSilent();
            const user = yield userManager.getUser();
            dispatch({ type: 'TOKEN_REFRESH_SUCCESS', user });
            setRunning(false);
        }
        catch (error) {
            if (error.error === 'login_required') {
                console.warn('silentRefresh() failed because user is not logged into IdP. Redirecting this window to login');
                yield userManager.removeUser();
                yield userManager.signinRedirect();
            }
            else {
                console.error('silentRefresh Cannot perform silent refresh of token', error);
                setRunning(false);
            }
        }
    });
}
function authenticate({ dispatch, userManager, setRunning }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (localStorage.getItem('isLoggedIn') === 'true') {
            yield resumeLogin({ dispatch, userManager, setRunning });
            setRunning(false);
        }
        else {
            const currentPath = location.pathname + location.search + location.hash;
            window.sessionStorage.setItem('destinationAfterAuthentication', currentPath);
            yield userManager.removeUser();
            yield userManager.signinRedirect();
        }
    });
}
const fakeUser = {
    profile: {
        preferred_username: 'TBD'
    }
};
export default function Main() {
    const { privateState, privateDispatch } = useContext(PrivateContext);
    const [running, setRunning] = useState(false);
    const { authenticated, authService, legacyMode, redirectInProgress, tokenRefreshRequested, wasLoggedIn, debugMode } = privateState;
    useEffect(() => {
        if (running)
            return;
        if (wasLoggedIn)
            return;
        if (!authService)
            return;
        if (!privateDispatch)
            return;
        if (redirectInProgress)
            return;
        if (legacyMode) {
            setRunning(true);
            window.localStorage.setItem('isLoggedIn', 'true');
            privateDispatch({ type: 'AUTHENTICATED', user: fakeUser });
            return;
        }
        if (!authenticated) {
            setRunning(true);
            authenticate({ dispatch: privateDispatch, userManager: authService.userManager, setRunning });
        }
        else if (tokenRefreshRequested) {
            setRunning(true);
            silentRefresh({ dispatch: privateDispatch, userManager: authService.userManager, setRunning });
        }
    });
    useEffect(() => {
        if (authenticated && privateDispatch) {
            privateDispatch({ type: 'RENDER_CHILDREN' });
        }
    }, [authenticated]);
    if (redirectInProgress)
        return null;
    if (debugMode === true) {
        if (authenticated) {
            return React.createElement(LoginStatus, { authenticated: authenticated, refreshing: tokenRefreshRequested });
        }
        else if (wasLoggedIn) {
            return React.createElement(LoggedOut, null);
        }
        else {
            return React.createElement("h1", null, "loading login state");
        }
    }
    if (!authenticated && wasLoggedIn) {
        return React.createElement(LoggedOut, null);
    }
    return null;
}
